import { amber, orange } from "@mui/material/colors";

import { misc, neutral } from "app/themes/colors";

import EnumDataSource from "../utils/enum-data-source.util";

export const CALL_DIRECTION_INCOMING = "incoming";
export const CALL_DIRECTION_OUTGOING = "outgoing";

export const CALL_DIRECTIONS = new EnumDataSource({
  [CALL_DIRECTION_INCOMING]: "Incoming",
  [CALL_DIRECTION_OUTGOING]: "Outgoing"
});

export const CALL_STATUS_ANSWERED = "answered";
export const CALL_STATUS_MISSED = "missed";
export const CALL_STATUS_RINGING = "ringing";
export const CALL_STATUS_NO_ANSWER = "no-answer";

export const CALL_STATUSES = new EnumDataSource({
  [CALL_STATUS_ANSWERED]: "Answered",
  [CALL_STATUS_MISSED]: "Missed",
  [CALL_STATUS_RINGING]: "Ringing",
  [CALL_STATUS_NO_ANSWER]: "No Answer"
});

export const LEAD_STATUS_NEW = "new";
export const LEAD_STATUS_IN_PROGRESS = "in_progress";
export const LEAD_STATUS_QUALIFIED = "qualified";
export const LEAD_STATUS_CONVERTED = "converted";
export const LEAD_STATUS_ARCHIVED = "archived";

export const LEAD_STATUSES = new EnumDataSource({
  [LEAD_STATUS_NEW]: "New",
  [LEAD_STATUS_IN_PROGRESS]: "In Progress",
  [LEAD_STATUS_QUALIFIED]: "Qualified",
  [LEAD_STATUS_CONVERTED]: "Converted",
  [LEAD_STATUS_ARCHIVED]: "Archived"
});

export const LEAD_STATUS_COLORS: Record<string, string> = {
  [LEAD_STATUS_NEW]: misc.selectedMenuitem,
  [LEAD_STATUS_IN_PROGRESS]: amber[400],
  [LEAD_STATUS_QUALIFIED]: orange[600],
  [LEAD_STATUS_CONVERTED]: misc.darkGreen,
  [LEAD_STATUS_ARCHIVED]: neutral[600]
};

export const LEAD_EMAIL_SENT_ACTION_TYPE = "email_sent";
export const LEAD_SMS_SENT_ACTION_TYPE = "sms_sent";
export const LEAD_EMAIL_OPENED_ACTION_TYPE = "email_opened";
export const LEAD_LINK_CLICKED_ACTION_TYPE = "link_clicked";
export const LEAD_PHONE_CALL_ACTION_TYPE = "phone_call";
export const LEAD_WIDGET_FORM_ACTION_TYPE = "widget_form";
export const LEAD_REPLIED_ACTION_TYPE = "lead_replied";

export const LEAD_ACTION_TYPES = new EnumDataSource({
  [LEAD_WIDGET_FORM_ACTION_TYPE]: "Widget Form",
  [LEAD_EMAIL_SENT_ACTION_TYPE]: "Email Sent",
  [LEAD_SMS_SENT_ACTION_TYPE]: "SMS Sent",
  [LEAD_EMAIL_OPENED_ACTION_TYPE]: "Email Opened",
  [LEAD_LINK_CLICKED_ACTION_TYPE]: "Link Clicked",
  [LEAD_PHONE_CALL_ACTION_TYPE]: "Phone Call",
  [LEAD_REPLIED_ACTION_TYPE]: "Lead Replied"
});

export const LEAD_ACTION_TYPE_COLORS: Record<string, string> = {
  [LEAD_EMAIL_SENT_ACTION_TYPE]: misc.selectedMenuitem,
  [LEAD_SMS_SENT_ACTION_TYPE]: misc.selectedMenuitem,
  [LEAD_EMAIL_OPENED_ACTION_TYPE]: misc.selectedMenuitem,
  [LEAD_LINK_CLICKED_ACTION_TYPE]: misc.selectedMenuitem,
  [LEAD_PHONE_CALL_ACTION_TYPE]: misc.selectedMenuitem,
  [LEAD_WIDGET_FORM_ACTION_TYPE]: misc.selectedMenuitem
};

export const PREFERRED_CHANNEL_TYPE_SMS = "SMS";
export const PREFERRED_CHANNEL_TYPE_EMAIL = "EMAIL";
export const PREFERRED_CHANNEL_TYPE_SMS_AND_EMAIL = "SMS_AND_EMAIL";

export const PREFERRED_CHANNEL_TYPES = new EnumDataSource({
  [PREFERRED_CHANNEL_TYPE_SMS]: "SMS",
  [PREFERRED_CHANNEL_TYPE_EMAIL]: "Email",
  [PREFERRED_CHANNEL_TYPE_SMS_AND_EMAIL]: "SMS & Email"
});

export const LEAD_CLICKED_RESPONSE_TYPE = "clicked";
export const LEAD_ANSWERED_RESPONSE_TYPE = "answered";
export const LEAD_LEFT_MESSAGE_RESPONSE_TYPE = "left_message";
export const LEAD_NO_ANSWER_RESPONSE_TYPE = "no_answer";
export const LEAD_BUSY_RESPONSE_TYPE = "busy";

export const LEAD_RESPONSE_TYPES = new EnumDataSource({
  [LEAD_CLICKED_RESPONSE_TYPE]: "Clicked",
  [LEAD_ANSWERED_RESPONSE_TYPE]: "Answered",
  [LEAD_LEFT_MESSAGE_RESPONSE_TYPE]: "Left Message",
  [LEAD_NO_ANSWER_RESPONSE_TYPE]: "No Answer",
  [LEAD_BUSY_RESPONSE_TYPE]: "Busy"
});

export const LEAD_RESPONSE_TYPE_COLORS: Record<string, string> = {
  [LEAD_CLICKED_RESPONSE_TYPE]: neutral[600],
  [LEAD_ANSWERED_RESPONSE_TYPE]: neutral[600],
  [LEAD_LEFT_MESSAGE_RESPONSE_TYPE]: neutral[600],
  [LEAD_NO_ANSWER_RESPONSE_TYPE]: neutral[600],
  [LEAD_BUSY_RESPONSE_TYPE]: neutral[600]
};

export const LEAD_SOURCE_TYPE_GOOGLE_ADS = "GoogleAds";
export const LEAD_SOURCE_TYPE_FACEBOOK = "Facebook";
export const LEAD_SOURCE_TYPE_INSTAGRAM = "Instagram";
export const LEAD_SOURCE_TYPE_TWITTER = "Twitter";
export const LEAD_SOURCE_TYPE_INTERNAL = "Internal";
export const LEAD_SOURCE_TYPE_CLINIC_WEBSITE_FORM = "Clinic Website - Form";
export const LEAD_SOURCE_TYPE_CLINIC_WEBSITE_WIDGET = "Clinic Website - Widget";
export const LEAD_SOURCE_TYPE_OTHER = "Other";

export const LEAD_SOURCE_TYPES = new EnumDataSource({
  [LEAD_SOURCE_TYPE_INTERNAL]: "Internal",
  [LEAD_SOURCE_TYPE_CLINIC_WEBSITE_FORM]: "Clinic Website - Form",
  [LEAD_SOURCE_TYPE_CLINIC_WEBSITE_WIDGET]: "Clinic Website - Widget",
  [LEAD_SOURCE_TYPE_GOOGLE_ADS]: "GoogleAds",
  [LEAD_SOURCE_TYPE_FACEBOOK]: "Facebook",
  [LEAD_SOURCE_TYPE_INSTAGRAM]: "Instagram",
  [LEAD_SOURCE_TYPE_TWITTER]: "Twitter",
  [LEAD_SOURCE_TYPE_OTHER]: "Other"
});

export const LEAD_SOURCE_TAG_TYPE = 1;
